module.exports = __webpack_public_path__ + "media/images/games/35gender/eggstr-b91d834564841df058163a492041d2d8.png";